function _define_property(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _object_spread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);
    if (typeof Object.getOwnPropertySymbols === "function") {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }
    ownKeys.forEach(function (key) {
      _define_property(target, key, source[key]);
    });
  }
  return target;
}
import React from "react";
export var IconCardPayment = function IconCardPayment(props) {
  return /*#__PURE__*/React.createElement("svg", _object_spread({
    xmlns: "http://www.w3.org/2000/svg",
    width: "100",
    height: "67",
    viewBox: "0 0 100 67",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4716_15990)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M91.8091 1.63965H8.1893C4.58551 1.63965 1.66406 4.52816 1.66406 8.09133V58.9082C1.66406 62.4714 4.58551 65.3599 8.1893 65.3599H91.8091C95.4129 65.3599 98.3343 62.4714 98.3343 58.9082V8.09133C98.3343 4.52816 95.4129 1.63965 91.8091 1.63965Z",
    stroke: "currentColor",
    strokeWidth: "3",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.66406 25.5352H98.3343",
    stroke: "currentColor",
    strokeWidth: "8"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4716_15990"
  }, /*#__PURE__*/React.createElement("rect", {
    width: "100",
    height: "67",
    fill: "white"
  }))));
};